module.exports = __webpack_public_path__ + "img/stratton-season-pass-desktop.jpg";